import { useState } from "react";
import PropTypes from 'prop-types';
import { Icon } from "../Icon/Icon";
import { Modal } from "../Modal/Modal";
import { Button } from "../Button/Button";
import { merger } from "../../common/Merger";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
(function () {
  if (typeof document === "undefined") {
    return;
  }
  const styles = ".kof-table .top-actions {\n  display: flex;\n  margin-bottom: 8px;\n}\n.kof-table .top-actions svg {\n  margin-right: 8px;\n}\n.kof-table .top-actions svg:hover {\n  cursor: pointer;\n}\n.kof-table table {\n  border-spacing: 0;\n  width: 100%;\n  border-collapse: collapse;\n}\n.kof-table table thead {\n  text-align: left;\n}\n.kof-table table td, .kof-table table th {\n  padding: 10px;\n}\n.kof-table table td {\n  white-space: pre-wrap;\n}\n.kof-table table th {\n  border-bottom: 1px solid #212529;\n}\n.kof-table table th.actions {\n  text-align: right;\n}\n.kof-table table tbody tr {\n  border-bottom: 1px solid lightgrey;\n}\n.kof-table table tbody tr.can-click td:hover {\n  cursor: pointer;\n}\n.kof-table table tbody tr.can-click td.actions:hover {\n  cursor: initial;\n}\n.kof-table table tbody td.actions {\n  text-align: right;\n}\n.kof-table table tbody td.actions svg {\n  padding: 2px;\n  vertical-align: middle;\n}\n.kof-table table tbody td.actions svg:hover {\n  cursor: pointer;\n}";
  const fileName = "Table_Table_35817f4d-ccd1-4705-b249-bedcdd114a6b";
  const element = document.querySelector("style[data-sass-component='Table_Table_35817f4d-ccd1-4705-b249-bedcdd114a6b']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
let filterDelayTimeout = null;
const createInitialFilters = columns => {
  const filters = {};
  columns.forEach(column => {
    filters[column] = '';
  });
  return filters;
};
const Table = props => {
  const [removingItem, setRemovingItem] = useState(null);
  const [filters, setFilters] = useState(props.filters ? createInitialFilters(props.filters.columns) : null);
  const canClickItem = props.actions && props.actions.onClickItem;
  const shouldRenderActionsColumn = props.actions && (props.actions.onSubmitRemoval || props.actions.extra);
  const onSubmitRemoval = () => {
    setRemovingItem(null);
    props.actions.onSubmitRemoval(removingItem);
  };
  const onChangeFilter = (column, value) => {
    const newFilters = merger.mergeObjects([filters, {
      [column.name]: value
    }]);
    setFilters(newFilters);
    if (props.filters.onChange) {
      props.filters.onChange(newFilters);
    }
    if (props.filters.onChangeDelayed) {
      clearTimeout(filterDelayTimeout);
      filterDelayTimeout = setTimeout(() => {
        props.filters.onChangeDelayed(newFilters);
      }, 1000);
    }
  };
  const renderValue = (item, column) => {
    const rawValue = item[column.name];
    if (column.format) {
      return column.format(rawValue, item);
    }
    return rawValue;
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "kof-table",
    children: [props.actions && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsxs("div", {
        className: 'top-actions',
        children: [props.actions.onClickAdd && /*#__PURE__*/_jsx(Icon, {
          type: 'add',
          onClick: props.actions.onClickAdd
        }), props.actions.onClickDownloadList && /*#__PURE__*/_jsx(Icon, {
          type: 'download',
          onClick: props.actions.onClickDownloadList
        }), props.actions.extraTop && props.actions.extraTop.map(element => element)]
      })
    }), /*#__PURE__*/_jsxs("table", {
      children: [/*#__PURE__*/_jsxs("thead", {
        children: [/*#__PURE__*/_jsxs("tr", {
          children: [props.columns.map(column => /*#__PURE__*/_jsx("th", {
            className: column.class,
            children: column.label
          }, column.name)), shouldRenderActionsColumn && /*#__PURE__*/_jsx("th", {
            className: 'actions'
          })]
        }), props.filters && /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [props.columns.map(column => /*#__PURE__*/_jsx("th", {
              children: filters.hasOwnProperty(column.name) && /*#__PURE__*/_jsx("input", {
                type: 'text',
                value: filters[column.name],
                onChange: event => onChangeFilter(column, event.target.value)
              })
            }, column.name)), shouldRenderActionsColumn && /*#__PURE__*/_jsx("th", {})]
          })
        })]
      }), /*#__PURE__*/_jsx("tbody", {
        children: props.items.map(item => {
          return /*#__PURE__*/_jsxs("tr", {
            className: canClickItem ? 'can-click' : null,
            children: [props.columns.map(column => {
              return /*#__PURE__*/_jsx("td", {
                className: column.class,
                onClick: canClickItem ? () => props.actions.onClickItem(item) : null,
                children: renderValue(item, column)
              }, column.name);
            }), shouldRenderActionsColumn && /*#__PURE__*/_jsx(_Fragment, {
              children: /*#__PURE__*/_jsxs("td", {
                className: 'actions',
                children: [props.actions.extra && props.actions.extra.map(extraAction => {
                  return extraAction(item);
                }), props.actions.onSubmitRemoval && /*#__PURE__*/_jsx(Icon, {
                  type: 'remove-trash',
                  onClick: () => setRemovingItem(item)
                })]
              })
            })]
          }, item.id);
        })
      })]
    }), props.actions && removingItem && /*#__PURE__*/_jsxs(Modal, {
      isOpen: true,
      onClose: () => setRemovingItem(null),
      children: [/*#__PURE__*/_jsx("p", {
        children: props.translate('crud.remove.are-you-sure', {
          name: removingItem[props.labelProperty]
        })
      }), /*#__PURE__*/_jsx(Button, {
        onClick: onSubmitRemoval,
        children: props.translate('crud.remove')
      })]
    })]
  });
};
Table.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    class: PropTypes.string,
    format: PropTypes.func
  })).isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired
  })).isRequired,
  translate: PropTypes.func,
  actions: PropTypes.shape({
    onClickAdd: PropTypes.func,
    onClickItem: PropTypes.func,
    onSubmitRemoval: PropTypes.func,
    onClickDownloadList: PropTypes.func,
    extraTop: PropTypes.arrayOf(PropTypes.object),
    extra: PropTypes.arrayOf(PropTypes.func)
  }),
  labelProperty: PropTypes.string,
  filters: PropTypes.shape({
    columns: PropTypes.array.isRequired,
    onChange: PropTypes.func,
    onChangeDelayed: PropTypes.func
  })
};
export { Table };